export default __webpack_public_path__ + "static/media/realestate-bedroom.2bed52a5.svg";